define.alias("shared/helpers/format-number-with-suffix", "preview-grid/helpers/format-number-with-suffix");